import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/red_heart.png'


const _withScopeId = n => (_pushScopeId("data-v-168e8bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home__footer" }
const _hoisted_2 = { class: "footer__love" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "heart"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, "Inkast 2022 — " + _toDisplayString(_ctx.currentYear), 1),
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.t("Home.footer.with")), 1),
      _hoisted_3,
      _createTextVNode(_toDisplayString(_ctx.t("Home.footer.love")), 1)
    ]),
    _createVNode(_component_router_link, {
      to: "/privacy",
      innerHTML: _ctx.t('Home.footer.termsAndPolicy')
    }, null, 8, ["innerHTML"])
  ]))
}